module.exports = __webpack_public_path__ + "img/autho_loading.e51ac980.gif";